// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"Z6-z","displaySixCardTiles":"_6-z"};